import { CircleAlert } from "lucide-react";
import React from "react";

const FullNameInput = ({ fullNameVal, handleFormData, error }: any) => {
  return (
    <>
      <div className="flex items-center gap-4">
        <div className="relative w-full">
          <input
            type="text"
            name="firstName"
            value={fullNameVal}
            onChange={(e) => {
              handleFormData("fullName", e.target.value);
            }}
            placeholder="Full Name *"
            className={`inputClass ${
              error === ""
                ? "focus:ring-indigo-600"
                : "focus:ring-red-600 text-red-900"
            }`}
          />

          {error !== "" && (
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
              <CircleAlert
                aria-hidden="true"
                className="h-5 w-5 text-red-500"
              />
            </div>
          )}
        </div>
      </div>

      <span className="text-red-600 text-xs font-medium mb-2">{error}</span>
    </>
  );
};

export default FullNameInput;
